import { Component, Input } from '@angular/core';

export type BatchEmailMode = 'notification' | 'payment';

@Component({
  selector: 'app-batch-email',
  templateUrl: './batch-email.component.html',
  styleUrls: ['./batch-email.component.less'],
  standalone: false
})
export class BatchEmailComponent {
  @Input() selectedRows: any[] = [];
  @Input() aclKey: string | undefined;
  @Input() country: string | undefined;

  modalVisible = false;

  get canBatchEmail(): boolean {
    return !!this.selectedRows && this.selectedRows.length > 0;
  }

  openSelector() {
    if (!this.canBatchEmail) return;
    this.modalVisible = true;
  }

  closeModal() {
    this.modalVisible = false;
  }
}
